/* eslint-disable react/jsx-indent */
import React from 'react';
import classnames from 'classnames';

import defaultLogoImg from '../../asset/images/default.png';
import PhoneListLayer from '../../component/mui/phone-list-layer';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import { formatOpenTime } from '../../helper/dish-helper';
import { validateForeignAreaCode } from '../../helper/common-helper';
import { isMiniProgramBrowser } from '../../helper/map';
import Toast from '../../component/mui/toast';
// eslint-disable-next-line
import { checkPositionOnMap } from '../../helper/map-TARGET_AREA';

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import shopText from '../../intl/messages/shop';
import mineText from '../../intl/messages/mine';

class ShopDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPhoneNumberErr: false,
      isShownPhoneList: false,
    };
  }

  setShopTitle() {
    const { commercialName, openStatus, commercialLogo } = this.props.shopDetail;
    const { shopHomeScan } = this.props;

    if (!!shopHomeScan) {
      return null;
    }

    return (
      <li className="o-list__item c-option">
        <div className="o-media">
          <span>
            <HttpsProtocolImage className="o-media__img" style={{ width: 48, borderRadius: 4 }} src={commercialLogo || defaultLogoImg} alt="" />
          </span>
          <div className="o-media__body o-media__body--centered" style={{ paddingLeft: 5 }}>
            <div className="c-description">
              <div className="c-description__title">{commercialName}</div>
              <div className="c-description__body">
                <span
                  className={classnames('o-label', {
                    'o-label--primary': openStatus,
                    'o-label--disabled': !openStatus,
                  })}
                >
                  {openStatus ? formatMessage(shopText.shopOpen) : formatMessage(shopText.shopClosed)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }

  setShopTime() {
    const { openTimeList } = this.props.shopDetail;
    const openTimeContent = formatOpenTime(openTimeList);
    return (
      <li className="o-list__item c-option">
        <div className="c-option__title-icon">
          <i className="o-icon-time" />
        </div>
        <div className="c-option__body">
          <FormattedMessage {...shopText.shopopenTime} />
          {openTimeContent || formatMessage(shopText.notConfig)}
        </div>
      </li>
    );
  }

  setShopAddress() {
    const { commercialAdress } = this.props.shopDetail;

    return (
      <li className="o-list__item c-option" onTouchTap={this.openMap}>
        <div className="c-option__title-icon">
          <i className="o-icon-location" />
        </div>
        <div className="o-text-ellipsis c-option__body">
          <div className="o-text-ellipsis">{commercialAdress}</div>
        </div>
        {!isMiniProgramBrowser() && (
          <div className="c-option__ending">
            <i className="o-icon-arrow--right" />
          </div>
        )}
      </li>
    );
  }

  setShopPhoneNumber() {
    const { serviceMobile, commercialPhone, nationTelCode } = this.props.shopDetail;

    return (
      <li className="o-list__item c-option" onTouchTap={this.showPhoneListLayer}>
        <div className="c-option__title-icon">
          <i className="o-icon-phone" />
        </div>
        <div className="c-option__body">
          {serviceMobile ? `${serviceMobile} ` : ''}
          {validateForeignAreaCode(nationTelCode)}
          {commercialPhone || ''}
          {!serviceMobile && !commercialPhone ? formatMessage(shopText.shopNull) : ''}
        </div>
        <div className="c-option__ending">
          <i className="o-icon-arrow--right" />
        </div>
      </li>
    );
  }

  setPhoneListLayer() {
    const { serviceMobile, commercialPhone, nationTelCode } = this.props.shopDetail;
    let phoneNumberList = [];

    if (serviceMobile && !/\*/.test(serviceMobile)) {
      phoneNumberList.push(serviceMobile);
    }

    if (commercialPhone && !/\*/.test(commercialPhone)) {
      phoneNumberList.push(`${validateForeignAreaCode(nationTelCode)}${commercialPhone}`);
    }

    if (!phoneNumberList.length) {
      phoneNumberList = [`${formatMessage(mineText.mineNull)}`];
    }

    return <PhoneListLayer phoneList={phoneNumberList} show={this.state.isShownPhoneList} closePhoneListLayer={this.closePhoneListLayer} />;
  }

  openMap = e => {
    const { shopDetail } = this.props;
    e.preventDefault();
    if (isMiniProgramBrowser()) return;
    checkPositionOnMap(shopDetail);
  };

  setShowPhoneNumberErr(show) {
    this.setState({
      isShowPhoneNumberErr: show,
    });
  }

  showPhoneListLayer = e => {
    e.preventDefault();
    const { serviceMobile = '', commercialPhone = '' } = this.props.shopDetail;
    if (/\*/.test(serviceMobile) && /\*/.test(commercialPhone)) {
      this.setShowPhoneNumberErr(true);
      return;
    }
    this.setState({
      isShownPhoneList: true,
    });
  };

  closePhoneListLayer = e => {
    e.preventDefault();
    this.setState({
      isShownPhoneList: false,
    });
  };

  render() {
    const { isShowPhoneNumberErr } = this.state;
    // const shopTitle = this.setShopTitle();
    const shopTime = this.setShopTime();
    const shopAddress = this.setShopAddress();
    const shopPhoneNumber = this.setShopPhoneNumber();
    const phoneListLayer = this.setPhoneListLayer();
    // console.log('isMiniProgramBrowser', isMiniProgramBrowser());
    return (
      <div className="o-mb">
        <ul className="o-list o-border--top o-border--bottom">
          {/* {shopTitle} */}
          {shopTime}
          {shopPhoneNumber}
          {shopAddress}
        </ul>
        {phoneListLayer}
        {isShowPhoneNumberErr && (
          <Toast
            clearErrorMsg={() => this.setShowPhoneNumberErr(false)}
            isShowIcon={false}
            errorMessage={formatMessage(shopText.shoplogToNext)}
            timeout={1500}
          />
        )}
      </div>
    );
  }
}

ShopDetail.propTypes = {
  fetchShopDetail: React.PropTypes.func,
  shopDetail: React.PropTypes.object,
  shopHomeScan: React.PropTypes.bool,
};

export default ShopDetail;



// WEBPACK FOOTER //
// ./src/component/shop-home/shop-detail.jsx